import React, { useState, useEffect, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import Condition from "yup/lib/Condition"
import { documentsActions } from "../../actions/documentsActions"

const CommentsList = ({
	commentList,
	showingCommentBoxId,
	setShowingCommentBox,
	item,
	idElement,
	setIdElement,
	setShowingCommentBoxId,
	addClassName,
	updateCommentCount = () => {},
}) => {
	/* ******************* REDUX STORE ******************* */

	const dispatch = useDispatch()

	const authentication = useSelector((state) => state.authtentication)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	const [comment, setComment] = useState("")
	const [commentRandom, setCommentRandom] = useState(Math.random())
	const [idEditing, setIdEditing] = useState(null)
	const [commentEditing, setCommentEditing] = useState("")

	/* ******************* END REACT STATES ******************* */

	/* ******************* VARIABLES ******************* */

	/* ******************* END VARIABLES ******************* */

	/* ******************* USE-EFFECTS ******************* */

	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */

	const onChangeCommentInput = (e) => {
		setComment(e.target.value)
	}
	/* ******************* END VARIABLES POST INITIALIZATION ******************* */

	const eliminar = (comment_id, document_id) => {
		dispatch(documentsActions.deleteComment(comment_id, document_id))
		setIdElement(Math.random())
	}
	const edit = (comment_id, comment) => {
		setIdEditing(comment_id)
		setCommentEditing(comment)
		setIdElement(Math.random())
	}
	const cancelEdit = () => {
		setIdEditing(null)
		setCommentEditing("")
	}
	const save = () => {
		//dispatch(documentsActions.setPriorityCustomTagAction(nameEditing, colorIdEditing, idEditing));
		dispatch(documentsActions.addComment(item.id, commentEditing, idEditing))
		cancelEdit()
	}

	const addTagSumbit = () => {
		dispatch(documentsActions.addComment(item.id, comment))
		setComment("")
		setIdElement(Math.random())
	}

	return (
		<Fragment>
			<div className={`addNewComment ${addClassName}`} style={{ display: showingCommentBoxId === item.id ? null : "none" }}>
				<div className="cerrar-comment">
					<i
						className="fas fa-times"
						onClick={(e) => {
							e.preventDefault()
							setShowingCommentBox(false)
							setShowingCommentBoxId(null)
						}}
					></i>
				</div>

				<form>
					<div id={"divComments_" + idElement} className="col-12 divBlock">
						{commentList
							? commentList?.map((item) => (
									<Fragment key={item.comment_id}>
										<div
											className="col-12 divBlock d-flex justify-content-center mb-3"
											data-comment-id={item.comment_id}
										>
											<div className="card" style={{ width: "85%" }}>
												<div className="card-body">
													<h5 className="card-title" style={{ fontSize: "20px" }}>
														{item.user_name}
													</h5>

													{idEditing === item.comment_id && item.user_id === authentication.user.token.userid ? (
														<textarea
															className="texterea-edit-comment"
															onChange={(e) => {
																e.preventDefault()
																setCommentEditing(e.target.value)
															}}
															defaultValue={commentEditing}
														></textarea>
													) : (
														<h6 className="card-subtitle mb-2 text-muted">{item.comment}</h6>
													)}
													<p className="card-text">
														{
															/*new Intl.DateTimeFormat('en-US', {
                                                                                year: 'numeric',
                                                                                month: 'long',
                                                                                day: '2-digit'
                                                                            }).format(new Date(item.comment_time))*/
															// new Intl.DateTimeFormat('es-ES', {
															//     year: 'numeric',
															//     month: '2-digit',
															//     day: '2-digit',
															//     hour: '2-digit',
															//     minute: '2-digit'
															// }).format(new Date(item.creation_time))

															new Date(new Date(item.creation_time)).toLocaleString("en-US", {
																year: "numeric",
																month: "long",
																day: "2-digit",
																hour: "2-digit",
																minute: "2-digit",
															})
														}
													</p>
													{/* 
                                                                        <a href="#"className="card-link">Card link</a>
                                                                        <a href="#"className="card-link">Another link</a>
                                                                        */}
												</div>
												{idEditing === item.comment_id ? (
													<div className="d-flex pb-2">
														<button
															disabled={commentEditing === "" ? true : false}
															className="btn btn-primary btn-sm"
															onClick={(e) => {
																e.preventDefault()
																save()
															}}
														>
															Save
														</button>
														<button
															className="btn btn-danger btn-sm"
															onClick={(e) => {
																e.preventDefault()
																cancelEdit()
															}}
														>
															Cancel
														</button>
													</div>
												) : item.user_id === authentication.user.token.userid ? (
													<div className="d-flex pb-2">
														<button
															className="commentEliminar text-danger"
															onClick={(e) => {
																e.preventDefault()
																eliminar(item.comment_id, item.doc_id)
																updateCommentCount(item.doc_id, commentList.length - 1)
															}}
														>
															<i className="bi bi-trash"></i>
														</button>
														<button
															className="commentEliminar text-primary"
															onClick={(e) => {
																e.preventDefault()
																edit(item.comment_id, item.comment)
															}}
														>
															<i className="bi bi-pencil"></i>
														</button>
													</div>
												) : null}
											</div>
										</div>
									</Fragment>
							  ))
							: null}
					</div>
					<input
						type="text"
						className="form-control"
						placeholder="Add a comment"
						onChange={onChangeCommentInput}
						value={comment}
						key={`coment_input_${commentRandom}`}
						name="addCommentText"
						onKeyPress={(e) => {
							if (e.key === "Enter") {
								e.preventDefault()
								addTagSumbit()
								updateCommentCount(item.id, commentList.length + 1)
							}
						}}
					/>
					<button
						disabled={comment === "" ? true : false}
						id="addCommentBtn"
						className="btn btn-primary btn-sm"
						type="submit"
						onClick={(e) => {
							e.preventDefault()
							addTagSumbit()
							updateCommentCount(item.id, commentList.length + 1)
						}}
					>
						<i className="fas fa-paper-plane fa-rotate-90"></i>
					</button>
				</form>
			</div>
		</Fragment>
	)
}

export default CommentsList
